import { Controller, useForm } from "react-hook-form";
import { SearchField } from "@ofqual/portal-components/components/SearchField";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { useMemo } from "react";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { aoServiceRefData } from "../../services";
import { loadingDataPortalLookups } from "../../redux/actions";

export const OrgSelect: React.FC = () => {
  const { token } = useSelector(authSelector);
  const dispatch = useDispatch();
  const { handleSubmit, control, setValue } = useForm();

  const mappedOrgLookupService = useMemo(
    () => ({
      get: (id: string) => aoServiceRefData.get(id.toString(), { token }),
      search: (params?: QueryParams) => {
        const innerParams = !!params
          ? { ...params, search: params.query || "" }
          : {}
        return aoServiceRefData.search(innerParams || {}, { token });
      },
    }),
    [token]
  );

  const onSubmit = (data: any) => {
    dispatch(loadingDataPortalLookups(data.organisationId));
  };

  return (
    <>
      <Controller
        control={control}
        name="organisationId"
        render={({ onChange, ...props }) => (
          <SearchField
            searchFieldVariant="single"
            label="Organisation"
            datatest="org-field"
            service={mappedOrgLookupService}
            readOnly={false}
            onChange={(e) => {
              setValue("organisationId", e.target.value);
              handleSubmit(onSubmit)();
            }}
            {...props}
          ></SearchField>
        )}
      />
    </>
  );
};
